import { render, staticRenderFns } from "./HomeRoundBanner.vue?vue&type=template&id=10ef8558&scoped=true"
import script from "./HomeRoundBanner.vue?vue&type=script&lang=js"
export * from "./HomeRoundBanner.vue?vue&type=script&lang=js"
import style0 from "./HomeRoundBanner.vue?vue&type=style&index=0&id=10ef8558&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ef8558",
  null
  
)

export default component.exports